import React from 'react';
import { InputWrapper, StyledInput, StyledInputProps, UnUserSelect } from './styles';

interface Props extends React.InputHTMLAttributes<HTMLInputElement>, StyledInputProps {}

const GhostInput = ({ textAlign = 'left', ...inputProps }: Props) => {
  return (
    <InputWrapper>
      <StyledInput autoComplete="off" textAlign={textAlign} {...inputProps} />
      <UnUserSelect />
    </InputWrapper>
  );
};

export default GhostInput;
